export default __webpack_public_path__ + "static/media/TigerReader.2474f3ab.png";